import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";

const LegalLayout = ({ title, lastUpdated, children }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAF7F2]" data-testid={`legal-page-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      {/* Header */}
      <nav className="border-b border-[#E5DFEC] bg-white">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/dhdh-logo.png" alt="DHDH" className="w-10 h-10 rounded-full object-cover" />
            <span className="font-medium text-[#6B4E8A]">Dental Hygiene Development Hub</span>
          </div>
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
            className="text-[#64748B] hover:text-[#6B4E8A]"
            data-testid="legal-back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Button>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 py-12 lg:py-16">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#8DB5A0] mb-3">Legal</p>
        <h1 className="text-4xl sm:text-5xl font-light text-[#6B4E8A] mb-3" style={{ fontFamily: "Outfit, sans-serif" }}>
          {title}
        </h1>
        <p className="text-sm text-[#64748B] mb-10">Last updated: {lastUpdated}</p>
        <div className="prose prose-slate max-w-none [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-2xl [&_h2]:font-medium [&_h2]:text-[#6B4E8A] [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-lg [&_h3]:font-medium [&_h3]:text-[#6B4E8A] [&_p]:text-[#475569] [&_p]:leading-relaxed [&_p]:my-3 [&_li]:text-[#475569] [&_li]:my-1 [&_a]:text-[#8DB5A0] [&_a]:underline">
          {children}
        </div>
      </article>

      <footer className="border-t border-[#E5DFEC] bg-white mt-16">
        <div className="max-w-4xl mx-auto px-6 py-6 text-xs text-[#94A3B8] flex flex-wrap items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} Dental Hygiene Development Hub</span>
          <div className="flex gap-5">
            <a href="/privacy" className="hover:text-[#6B4E8A]">Privacy</a>
            <a href="/terms" className="hover:text-[#6B4E8A]">Terms</a>
            <a href="mailto:support@dhdh.ca" className="hover:text-[#6B4E8A]">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LegalLayout;
